export default "__VITE_ASSET__DbAm0b_7__"